import React from "react";

export const MobileFeedIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_15753_113891" fill="white">
        <path d="M6.5 2.99991C6.5 1.67443 7.57452 0.599915 8.9 0.599915H16.1C17.4255 0.599915 18.5 1.67443 18.5 2.99991V10.1999C18.5 11.5254 17.4255 12.5999 16.1 12.5999H8.9C7.57452 12.5999 6.5 11.5254 6.5 10.1999V2.99991Z" />
      </mask>
      <path
        d="M6.5 2.99991C6.5 1.01169 8.11177 -0.600085 10.1 -0.600085H14.9C16.8882 -0.600085 18.5 1.01169 18.5 2.99991C18.5 2.33717 17.4255 1.79991 16.1 1.79991H8.9C7.57452 1.79991 6.5 2.33717 6.5 2.99991ZM18.5 12.5999H6.5H18.5ZM6.5 12.5999V0.599915V12.5999ZM18.5 0.599915V12.5999V0.599915Z"
        fill="#848484"
        mask="url(#path-1-inside-1_15753_113891)"
      />
      <mask id="path-3-inside-2_15753_113891" fill="white">
        <path d="M4.09961 5.89991C4.09961 4.57442 5.17413 3.49991 6.49961 3.49991H18.4996C19.8251 3.49991 20.8996 4.57443 20.8996 5.89991V13.0999C20.8996 14.4254 19.8251 15.4999 18.4996 15.4999H6.49961C5.17413 15.4999 4.09961 14.4254 4.09961 13.0999V5.89991Z" />
      </mask>
      <path
        d="M4.09961 5.89991C4.09961 3.746 5.8457 1.99991 7.99961 1.99991H16.9996C19.1535 1.99991 20.8996 3.746 20.8996 5.89991C20.8996 5.40285 19.8251 4.99991 18.4996 4.99991H6.49961C5.17413 4.99991 4.09961 5.40285 4.09961 5.89991ZM20.8996 15.4999H4.09961H20.8996ZM4.09961 15.4999V3.49991V15.4999ZM20.8996 3.49991V15.4999V3.49991Z"
        fill="#848484"
        mask="url(#path-3-inside-2_15753_113891)"
      />
      <rect
        x="1.4"
        y="7.49991"
        width="22.2"
        height="15"
        rx="3.9"
        stroke="#848484"
        strokeWidth="1.8"
      />
    </svg>
  );
};
